import designItem from './DesignDate.vue'
const DesignDate = {
  install: function (Vue) {
    Vue.component('DesignDate', designItem)
  }
}
export default DesignDate
